import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

/* --------------------------------------------------
   🔐 SHARED LOGOUT FUNCTION (WEB + APK)
-------------------------------------------------- */
export async function performLogout({
  setIsLoggedIn,
  navigate,
  redirectTo = "/",
}) {
  try {
    const config = {};

    // 🌐 WEB (HttpOnly cookie)
    if (!Capacitor.isNativePlatform()) {
      config.withCredentials = true;
    }

    // 📱 APK (Bearer token)
    if (Capacitor.isNativePlatform()) {
      const { value } = await Preferences.get({ key: "authToken" });
      if (value) {
        config.headers = {
          Authorization: `Bearer ${value}`,
        };
      }
    }

    // ✅ Dedicated logout route (NO auth middleware)
    await axios.post(
      "https://metisel.com/api/logout",
      null,
      config
    );
  } catch (error) {
  } finally {
    // 📱 APK → always remove token
    if (Capacitor.isNativePlatform()) {
      await Preferences.remove({ key: "authToken" });
    }

    // 🔥 UI reset
    setIsLoggedIn(false);
    navigate(redirectTo, { replace: true });
  }
}

/* --------------------------------------------------
   🚪 LOGOUT PAGE (ROUTE-BASED)
-------------------------------------------------- */
export const Logout = ({ setIsLoggedIn, redirectTo = "/" }) => {
  const navigate = useNavigate();

  useEffect(() => {
    performLogout({ setIsLoggedIn, navigate, redirectTo });
  }, [setIsLoggedIn, navigate, redirectTo]);

  return <p>Logging out...</p>;
};

export default Logout;